// extracted by mini-css-extract-plugin
export default {"textarea-control":"textarea_textarea-control__zViRu","description":"textarea_description__rRH7n","textarea":"textarea_textarea__QJpz4"};